"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlStyleFormaters_1 = __importDefault(require("../../ControlStyleFormaters"));
const colorComputers_1 = require("../../ControlStyleFormaters/shared/colorComputers");
const StyleFormaterContext_1 = __importDefault(require("./StyleFormaterContext"));
const WithStyleFormaterContext = ({ shadeBases, fontSize, children, }) => {
    const styleFormater = (0, react_1.useMemo)(() => (0, ControlStyleFormaters_1.default)((0, colorComputers_1.getPaletteShades)(shadeBases || {
        primary: '#afafaf',
        secondary: '#92d637',
        black: 'black',
    }), fontSize || 12, undefined), [shadeBases, fontSize]);
    return (react_1.default.createElement(StyleFormaterContext_1.default.Provider, { value: styleFormater }, children));
};
exports.default = WithStyleFormaterContext;
